/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiReportResponseFromJSON(json) {
    return ApiReportResponseFromJSONTyped(json, false);
}
export function ApiReportResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'favourite': !exists(json, 'favourite') ? undefined : json['favourite'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
export function ApiReportResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'favourite': value.favourite,
        'id': value.id,
        'name': value.name,
    };
}
